import { ReactNode, useState } from "react";
import ApiContext from "./context";
import { WorkOrderApi } from "./work-order-api";

type ApiProviderProps = {
  children: ReactNode
}

export default function (p: ApiProviderProps) {
  const storageToken = localStorage.getItem("token") ?? undefined;
  const [token, setToken] = useState<string | undefined>(storageToken);
  const api = new WorkOrderApi(token);

  return (
    <ApiContext.Provider value={{
      api,
      setToken,
    }}>
      {p.children}
    </ApiContext.Provider>
  );
}